<!-- This uses classes from the dialog component and should be kept in sync -->
<div class="se-dialog__overlay"></div>
<div class="se-dialog__container">
  <div class="se-modal__content">
    <div class="se-modal__header">
      <div class="se-modal__title">{{ title }}</div>
      <div class="se-modal__close">
        <button (click)="cancel()" type="button" class="se-dialog-button--icon">
          <se-icon name="remove" size="700"></se-icon>
        </button>
      </div>
    </div>
    <div class="se-dialog__content">
      <ng-content></ng-content>
    </div>
  </div>
  <se-dialog-footer
    [se-data-buttons]="buttons"
    (se-data-action)="awaitAction($event)">
  </se-dialog-footer>
</div>
